import React, { useEffect, useMemo, useState } from 'react';
import WarningBanner from '@/components/salesman/WarningBanner';
import BottomNav from '@/components/salesman/BottomNav';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Package, Search } from 'lucide-react';
import api, { fmtIDR } from '@/lib/api';

export default function SalesmanCatalog() {
  const [products, setProducts] = useState([]);
  const [query, setQuery] = useState('');

  useEffect(() => {
    api.get('/products?active_only=true')
      .then(({ data }) => setProducts(data))
      .catch((e) => console.error('[SalesmanCatalog] gagal load produk:', e));
  }, []);

  const filtered = useMemo(() => products.filter((p) => {
    if (!query) return true;
    const q = query.toLowerCase();
    return p.name.toLowerCase().includes(q) || p.sku.toLowerCase().includes(q) || p.category.toLowerCase().includes(q);
  }), [products, query]);

  return (
    <div className="min-h-screen bg-background pb-24">
      <WarningBanner />
      <div className="px-4 py-4 sticky top-0 bg-background z-30 border-b">
        <div className="font-heading font-semibold text-lg">Katalog Stok</div>
        <div className="relative mt-2">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input placeholder="Cari barang..." value={query} onChange={(e) => setQuery(e.target.value)} className="pl-9" data-testid="salesman-catalog-search" />
        </div>
      </div>

      <div className="px-4 py-4 space-y-3 max-w-md mx-auto">
        {filtered.length === 0 ? (
          <div className="text-center py-12 text-sm text-muted-foreground">Tidak ada barang</div>
        ) : filtered.map((p) => {
          const low = p.stock > 0 && p.stock <= (p.low_stock_threshold || 5);
          const out = p.stock <= 0;
          return (
            <Card key={p.id} data-testid={`salesman-product-${p.id}`}>
              <CardContent className="p-3">
                <div className="flex gap-3">
                  <div className="h-20 w-20 rounded-lg bg-muted shrink-0 overflow-hidden">
                    {p.photo_url ? <img src={p.photo_url} alt={p.name} className="h-full w-full object-cover" /> : <div className="h-full w-full flex items-center justify-center"><Package className="h-8 w-8 text-muted-foreground" /></div>}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-mono text-[10px] text-muted-foreground">{p.sku}</div>
                    <div className="font-medium text-sm line-clamp-2">{p.name}</div>
                    <div className="flex items-center gap-2 mt-1">
                      <Badge variant="secondary" className="text-[10px]">{p.category}</Badge>
                      <div className={`text-xs ${out ? 'text-rose-700 font-bold' : low ? 'text-rose-700 font-semibold' : 'text-emerald-700'}`}>
                        {out ? 'Habis' : `Stok ${p.stock}`}
                      </div>
                    </div>
                    <div className="font-heading font-semibold text-primary mt-1 tabular-nums">{fmtIDR(p.selling_price)}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <BottomNav />
    </div>
  );
}
